module.exports = __webpack_public_path__ + "img/OP.5c022994.jpg";